import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  adminBookingsApi,
  adminBookingsKeys,
  type AdminBookingListParams,
} from '@/features/admin-bookings/api/admin-bookings.api';

export function useAdminBookings(params: AdminBookingListParams) {
  return useQuery({
    queryKey: adminBookingsKeys.list(params),
    queryFn: () => adminBookingsApi.list(params),
    placeholderData: keepPreviousData,
  });
}

/** Shared by the sidebar badge, dashboard and bookings page, so one cached request serves all. */
export function useAdminBookingStats() {
  return useQuery({
    queryKey: adminBookingsKeys.stats(),
    queryFn: adminBookingsApi.stats,
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}

export function useAdminBooking(id: string | null) {
  return useQuery({
    queryKey: adminBookingsKeys.detail(id ?? ''),
    queryFn: () => adminBookingsApi.getById(id!),
    enabled: Boolean(id),
  });
}
